/**
 * PM-JSON projection kept current from the Y.Doc so REST reads / full-text search are unaffected
 * (AC 14.4). Serializer logic is PORTED (copied) from `knowit-main/shared/editor`, not imported —
 * importing would couple v2 back to a v1 path. INTERNAL: takes a PM node, returns plain JSON.
 */

import type { Node as PMNode } from 'prosemirror-model';

/** Serialize the document node to the PM-JSON shape stored in `documents.contentV2`. */
export function toContentV2(doc: PMNode): unknown {
  return doc.toJSON();
}
